import { render } from "./About.vue?vue&type=template&id=840776f8&scoped=true"
import script from "./About.vue?vue&type=script&lang=js"
export * from "./About.vue?vue&type=script&lang=js"

import "@/assets/pokemon.css?vue&type=style&index=0&id=840776f8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-840776f8"

export default script